export default __webpack_public_path__ + "images/26f8b090f0a0d95e15ca4b3bf5e608fd-auto.webp";